import { ShoppingCartOutlined, ShoppingOutlined } from '@ant-design/icons';
import { CogIcon } from '@heroicons/react/24/outline';
import { Button, MenuProps } from 'antd';
import { useCallback } from 'react';
import { Link, useNavigate } from 'react-router';

import sharedStyles from '../../../side-nav/SideNav.shared.module.css';

import { useStopPropagation } from '../../../_shared/hooks/use-stop-propagation';
import { JOBS_ITEM_KEY, JOBS_ITEM_KEY_PREFIX, searchableMenuItemLabelMap } from '../../../side-nav/sidenav-constants';
import { JobListItem } from '../jobs-api';

function JobsNavItem({ model }: { model: JobListItem }) {
  const path = `/jobs/${model.id}`;

  return (
    <div className={sharedStyles.navLabel}>
      <Link to={path}>{model.name}</Link>
      <small className="sidebar-nav-item-service-status">{model.enabled ? 'ENABLED' : 'DISABLED'}</small>
    </div>
  );
}

function JobsNav() {
  const navigate = useNavigate();
  const handleButtonClick = useStopPropagation(useCallback(() => navigate('/published-manifests?appType=task'), [navigate]));

  return (
    <div data-testid="side-nav-jobs" className="sidebar-nav-item-title-icon-container">
      <div>{searchableMenuItemLabelMap.JOBS}</div>
      <Button onClick={handleButtonClick} icon={<ShoppingCartOutlined />} type="text" />
    </div>
  );
}

function getJobsNavItems({ jobs, loading }: { jobs: JobListItem[]; loading: boolean }) {
  if (!jobs.length) {
    return [
      {
        label: loading ? 'Loading…' : 'No installed jobs',
        key: `${JOBS_ITEM_KEY_PREFIX}empty`,
        disabled: true,
      },
    ];
  }

  return jobs.map((job) => ({
    label: <JobsNavItem model={job} />,
    icon: job.logo ? (
      <img src={job.logo} alt="logo" style={{ height: '16px', width: '16px', objectFit: 'contain' }} />
    ) : (
      <CogIcon height={16} width={16} />
    ),
    key: `${JOBS_ITEM_KEY_PREFIX}${job.id}`,
    className: sharedStyles.fullHeightNavItem,
    title: job.name,
  }));
}

export function getJobsNav({ jobs, loading }: { jobs: JobListItem[]; loading: boolean }): Required<MenuProps>['items'][number] {
  return {
    label: <JobsNav />,
    key: JOBS_ITEM_KEY,
    icon: <ShoppingOutlined />,
    children: getJobsNavItems({ jobs, loading }),
  };
}
